module.exports = __webpack_public_path__ + "static/media/newmsg.86576bb5.mp3";